import { useEffect, useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { useLazyQuery } from '@apollo/client';
import { Queries } from 'services/apollo';
import { useSettings } from 'contexts/Settings';

const useAlgoliaSearchClient = (indexName: string, companyId: string = '') => {
  const { settings } = useSettings();
  const [searchClient, setSearchClient] = useState<any>(null);
  const [getSearchToken, searchToken] = useLazyQuery(Queries.getSearchToken, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const fetchSearchToken = async () => {
      const getSearchTokenVariables = {
        companyId: '',
        adminSearch: true,
      };

      if (companyId) {
        getSearchTokenVariables.companyId = companyId;
        getSearchTokenVariables.adminSearch = false;
      } else {
        getSearchTokenVariables.adminSearch = true;
        getSearchTokenVariables.companyId = '';
      }

      if (!searchToken?.called) {
        await getSearchToken({
          variables: getSearchTokenVariables,
        });
      }
    };

    const initializeSearchClient = () => {
      if (searchToken?.data?.getSearchToken) {
        setSearchClient(
          algoliasearch(
            settings.REACT_APP_ALGOLIA_APP_ID || '',
            searchToken.data.getSearchToken,
            {},
          ),
        );
      }
    };

    fetchSearchToken();
    initializeSearchClient();
  }, [searchToken, getSearchToken, settings.REACT_APP_ALGOLIA_APP_ID, indexName, companyId]);

  return searchClient;
};

export default useAlgoliaSearchClient;